export default "__VITE_ASSET__CWywfZZk__"